module.exports = __webpack_public_path__ + "img/envelope-open.b2ce833f.svg";